import { useCallback, useEffect, useState } from "react"
import { useFarmerProfile } from "../../core/context/farmerProfileContext"
import FormDetailsScreen from "../../screen/FormDetailsScreen"
import Send from "../../core/communication"
import { getFormsSteps, groupFormStepsByName } from "../../core/utils/farmProfile"
import { useParams, useNavigate } from "react-router-dom"
import { customToast } from "../../components/Toast"
import { debounce } from "lodash"
import { useScope } from "../SelectProjectCompanyContainer"
import { useSelector } from "react-redux"

const obterGrupos = (arr, formStepsGrouped) => {
  return arr.reduce((result, item) => {
    const key = item.label
    if (formStepsGrouped.hasOwnProperty(key)) {
      result[key] = formStepsGrouped[key][0]?.groups
    }
    return result
  }, {})
}

const options = [
  {
    value: 1,
    label: "Sanidade animal",
    type: "open",
  },
  {
    value: 2,
    label: "Manejo animal",
    type: "draft",
  },
  {
    value: 3,
    label: "Gestão financeira",
    type: "schedule",
  },
  {
    value: 4,
    label: "Tecnologias, equipamentos e maquinários",
    type: "closed",
  },
  {
    value: 5,
    label: "Geração de demanda",
    type: "closed",
  },
  {
    value: 6,
    label: "Tecnologias, equipamentos e maquinários",
    type: "closed",
  },
  {
    value: 7,
    label: "Geração de demanda",
    type: "closed",
  },
]

const FormDetailsContainer = ({ handleOpenFormFill, showForm }) => {
  const { userId } = useParams()
  const navigate = useNavigate()
  const { scope } = useScope()
  const { hideMainCard, mainCardStatus, setPageName, pageName } = useFarmerProfile()
  const [formAddModal, setFormAddModal] = useState(false)
  const [formStepsAddModal, setFormStepsAddModal] = useState(false)
  const [formSteps, setFormSteps] = useState([])
  const [allSteps, setAllSteps] = useState(true)
  const [selectedForm, setFormList] = useState([])
  const [formModalId, setFormModalId] = useState("")
  const [formTitle, setFormTitle] = useState("")
  const [selectedSteps, setSelectedSteps] = useState([])
  const [selectedGroups, setSelectedGroups] = useState([])
  const [formStepsGrouped, setFormStepsGrouped] = useState([])
  const [groupForms, setGroupForms] = useState([])
  const [indicatorTabsOptions, setIndicatorTabsOptions] = useState({})
  const [initialFormList, setInitialFormList] = useState([])
  const [loadingSelectedForm, setLoadingSelectedForm] = useState(false)
  const [filteredForms, setFilteredForms] = useState([])
  const [searchTerm, setSearchTerm] = useState("")
  const [loadingFormAndSteps, setLoadingFormAndSteps] = useState(false)

  const loadFormsAndStepsToSelect = async () => {
    try {
      setLoadingSelectedForm(true)
      const res = await Send.get(`/forms-projects/project/${scope?.id}/producer/${userId}`)
      setFormList(res)
    } catch (error) {
      console.log("Error -> ", error)
    } finally {
      setLoadingSelectedForm(false)
    }
  }

  const loadFormsAndSteps = async () => {
    try {
      setLoadingFormAndSteps(true)
      const res = await Send.get(`/forms/${formModalId}`)

      setFormStepsGrouped(groupFormStepsByName(res?.screens))
      setIndicatorTabsOptions(getFormsSteps(res.screens))
    } catch (error) {
      console.log("Error -> ", error)
    } finally {
      setLoadingFormAndSteps(false)
    }
  }

  const loadInitialFormList = async () => {
    try {
      const response = await Send.get(
        `/events-sector/started-forms/producer/${userId}/project/${scope?.id}`,
      )

      if (!Array.isArray(response)) {
        throw new Error()
      }

      setInitialFormList(response)
    } catch (error) {
      console.log("error", error)
      customToast("Erro ao buscar lista de formulários iniciados", "error")
    }
  }

  useEffect(() => {
    if (userId) {
      loadInitialFormList()
    }
  }, [userId])

  useEffect(() => {
    if (formStepsAddModal && formModalId !== "") {
      loadFormsAndSteps()
    }
  }, [formModalId, formStepsAddModal])

  useEffect(() => {
    if (selectedSteps && selectedSteps?.length) {
      setSelectedGroups(groupForms?.map((accordion) => accordion?.id) || [])
    }
  }, [selectedSteps])

  useEffect(() => {
    if (selectedForm || formAddModal) {
      setFilteredForms(selectedForm)
    }
  }, [selectedForm, formAddModal])

  useEffect(() => {
    loadFormsAndStepsToSelect()
  }, [])

  const handleClickItem = (item) => {
    hideMainCard(null, false)
    setPageName(item?.title)
    handleOpenFormFill()
  }

  const handleSelectedForm = (item) => {
    setFormStepsAddModal(true)
    setFormModalId(item.id)
    setFormTitle(item?.title)
  }

  const handleSelectedSteps = (value) => {
    setSelectedSteps(value)
    if (Array.isArray(value)) {
      const grupos = obterGrupos(value, formStepsGrouped)
      const todosGrupos = Object.keys(grupos).flatMap((key) => grupos[key])
      setGroupForms(todosGrupos)
      setSelectedGroups(todosGrupos?.map((accordion) => accordion.id))
    } else {
      const grupoUnico = formStepsGrouped[value.label]?.[0]?.groups

      if (grupoUnico) {
        setGroupForms(grupoUnico)
        setSelectedGroups(grupoUnico?.map((accordion) => accordion.id))
      } else {
        setGroupForms([])
        setSelectedGroups([])
      }
    }
  }

  const handleSelectedGroups = (e) => {
    const { checked, value } = e.target
    setSelectedGroups((prev) => (checked ? [...prev, value] : prev.filter((val) => val !== value)))
  }

  const handleSelectedAllGroups = (e) => {
    setSelectedGroups(e.target.checked ? groupForms?.map((accordion) => accordion.id) : [])
  }

  const handleChangeFilter = (e) => {
    const { value } = e.target
    setSearchTerm(value)
    filterFormByTitle(value)
  }

  const filterFormByTitle = useCallback(
    debounce((term) => {
      if (!selectedForm) return
      const result = formsFilter(selectedForm, term)
      setFilteredForms(result)
    }, 300),
    [selectedForm],
  )

  const handleCloseFormStepsAddModal = () => {
    setFormStepsAddModal(false)
    setSelectedGroups([])
    setAllSteps(true)
    setSelectedSteps([])
    setPageName("Perfil do(a) beneficiário(a)")
  }

  const handleCloseFormAddModal = () => {
    setFormAddModal(false)
    setSearchTerm("")
    setFilteredForms([])
    handleCloseFormStepsAddModal()
    setPageName("Perfil do(a) beneficiário(a)")
  }

  const handleAddSteps = () => {
    setPageName(formTitle)
    navigate(
      `/farmer/profile/${userId}?context=false&form=${formModalId}&steps=${selectedGroups.join(
        "%2C",
      )}&projectId=${scope?.id}&category=startedForms`,
    )
  }

  const handleOpenForm = (formDetails) => {
    setPageName(formDetails?.title)
    navigate(
      `/farmer/profile/${userId}?context=${formDetails?.id}&form=${formDetails?.formId}&category=startedForms`,
    )
  }

  return (
    <FormDetailsScreen
      {...{
        mainCardStatus,
        handleClickItem,
        handleSelectedForm,
        showForm,
        selectedForm: filteredForms,
        loadingSelectedForm,
        loadingFormAndSteps,
        setFormAddModal,
        formAddModal,
        setFormStepsAddModal,
        formStepsAddModal,
        handleCloseFormStepsAddModal,
        handleCloseFormAddModal,
        setAllSteps,
        allSteps,
        handleSelectedSteps,
        handleSelectedGroups,
        selectedGroups,
        handleSelectedAllGroups,
        formSteps,
        groupForms,
        indicatorTabsOptions,
        options,
        handleAddSteps,
        initialFormList,
        handleOpenForm,
        handleChangeFilter,
        setSelectedSteps,
      }}
    />
  )
}

export default FormDetailsContainer

const formsFilter = (data, searchTerm) => {
  let filteredData = data || []

  if (searchTerm) {
    filteredData = filteredData.filter((item) =>
      item?.title?.toLowerCase().includes(searchTerm?.toLowerCase()),
    )
  }

  return filteredData
}
